
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from "@mui/material";
import { useShowAlert } from '../../../../context/AlertContext';
import { useNetwork } from '../../../../context/NetworkContext';
import Messages from "../../../../constants/Messages";
import AxiosInstance from "../../../../utils/AxiosInstance";
import handleError from "../../../../constants/handleError";
import { XIcon } from '../../../../constants/Icons';

const AddStaff = ({ isOpen, onClose,setFilteredData,setTotalItems ,handleView,selectedStaff}) => {

    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [userName, setUserName] = useState("");    
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [error, setErrors] = useState({});
    const nameRef = useRef(null);
    const userNameRef = useRef(null);
    const passwordRef = useRef(null);
    const buttonRef = useRef(null)
    const suggestionRef = useRef([])
    const wrapperRef = useRef(null);
    const { checkNetwork } = useNetwork();
    const showAlert = useShowAlert();

    useEffect(() => {
      if (selectedStaff) {
        setName(selectedStaff?.staffName);
        setPassword("");
        setUserName(selectedStaff?.userName);            
        }
    },[selectedStaff]);
    
useEffect(() => {
  function handleClickOutside(e) {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setSuggestions(false);
      setErrors("");
    }
  }
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

    if (!isOpen) return null;

    const validateForm = async () => {        
        const errors = {};
        if (!selectedStaff) {
            if (!name) {           
                errors.name = Messages.ERROR.NAME_EMPTY;
            } else if (!userName) {           
                errors.userName = Messages.ERROR.USER_NAME_EMPTY;
            } else if (userName.length < 3) {
                errors.userName = "UserName must be between 3-100 characters.";
            } else {  
                const available = await checkUserNameAvailability(userName);
                if (!available) {
                    errors.userNameAvailable = "Try another";
                }else if (!password) {             
                            errors.password = Messages.ERROR.PASSWORD_EMPTY;
                        } else if (password.length < 3) {
                            errors.password = "Password must be between 3-16 characters.";
                        } 
                }
                }
       else{
           if (name !== selectedStaff.staffName && !name) {
            errors.name = Messages.ERROR.NAME_EMPTY;
        }
        if (password && password.length < 3) {
            errors.password = "Password must be between 3-16 characters.";
        }
       }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {          
            setHighlightedIndex(-1);
            const firstErrorField = Object.keys(errors)[0];
            switch (firstErrorField) {
                case 'name':
                    nameRef.current?.focus();
                    break;
                case 'userName':
                case 'userNameAvailable':     
                    userNameRef.current?.focus();
                    break;
                case 'password':
                    passwordRef.current?.focus();
                    break;
                default:
                    break;
            }
        }
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const isValid = await validateForm(); 
        if (!isValid) return;
        selectedStaff ? handleUpdate():handleAdd();
    };

    const handleAdd = async () => {
        setBtnLoading(true);
        try {
            if (!checkNetwork()) return;
            const data={
              staffName: name,
              userName: userName,
              password: password
            }           
            const response = await AxiosInstance.post(`module/staff/`, data);            
            handleClose();
            showAlert("success", Messages.SUCCESS.STAFF_ADDED);
            setFilteredData(prev =>[response.data.results,...prev ]);  
            setTotalItems(prev => prev + 1); 
             await AxiosInstance.post("permissions/group", {
                staffId: response.data.results._id,
                groupId: "SALE_ADMIN",
                action: "ENABLE"
             }); 
            handleView(response.data.results)              
            setBtnLoading(false);            
        } catch (error) {
            if (
            error.response &&
            error.response.status === 409 &&
            error.response.data.code === "DUPLICATE_ENTRY"
            ) {
            userNameRef.current?.focus();
            return;
            }else{
            handleError(error, showAlert);
            return false;
    }
        } finally {
            setBtnLoading(false);
        }
    };

    const handleUpdate = async () => {     
        try {
            if (!checkNetwork()) return;
             if (name === selectedStaff.staffName && !password) {
                passwordRef.current?.focus();
                showAlert("success", Messages.SUCCESS.STAFF_UPDATED);
                return;
            }

            const data = {};

            if (name !== selectedStaff.staffName) {
                data.staffName = name;
            }
            if (password) {
                data.password = password;
            }            

            if (Object.keys(data).length === 0) {
                passwordRef.current?.focus();
                showAlert("warning", "No changes to update");
                return;
            }          
            const response = await AxiosInstance.patch(`module/staff/${selectedStaff._id}`, data);                  
            handleClose();
            showAlert("success", Messages.SUCCESS.STAFF_UPDATED);
             setFilteredData(prev => prev.map(staff => 
            staff._id === selectedStaff._id ? response.data.results : staff
            ));                           
            setBtnLoading(false);            
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } 
    };

    const handleClose = () => {
        setName("")
        setPassword("")
        setUserName("")
        setErrors({});
        onClose();
    };

    const handleEnterFocus = (e, nextRef) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if((e.target === nameRef.current && !name.trim()) || (e.target === userNameRef.current && !userName.trim()) ||  (e.target === passwordRef.current && !password.trim())){
            if(!validateForm()) return;
          }
          if (selectedStaff && e.target === nameRef.current) {
            passwordRef.current?.focus();
        } else {
          nextRef?.current?.focus();
        }  
        }
      };

    const stopEventPropagation = (e) => e.stopPropagation();

    const checkUserNameAvailability = async (generatedUsername) => {
            
        if (!generatedUsername) return;    
        try { 
          const response = await AxiosInstance.get(`module/staff/username/availability?userName=${generatedUsername}`);  
           if (response.data?.results?.availability === false) {
             const newSuggestions = [
                generatedUsername + "1",
                generatedUsername + "2",
                generatedUsername + "3",
             ];
             setSuggestions(newSuggestions)
             setHighlightedIndex(0);
              return false;            
          } else {        
           setSuggestions([]);
           setErrors("")
            return true; 
           }
        }  catch (error) {
            handleError(error, showAlert);
            return false;
        }    
    };

    const handleSuggestionClick = async  (suggestion) => {
        setUserName(suggestion);
        const isAvailable = await checkUserNameAvailability(suggestion);     
        
       if (isAvailable) {
        setSuggestions([]);
      passwordRef.current?.focus();
       }
    };
    

    return (
        <div>
            <div className="modal-backdrop show"></div>
            <div
                className="modal show"
                id="StoreModal"
                tabIndex="0"
                aria-modal="true"
                role="dialog"
                style={{ display: "block" }}
            >

                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    onClick={stopEventPropagation}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">{selectedStaff?"Edit Staff" :"Add Staff"}</h6>
                            <button type="button" className="btn-close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close" fdprocessedid="jgxcje"></button>
                        </div>
                        <div className="modal-body bg-light">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <div className="row g-3">
                                       <div className="col-lg-12">
                                            <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
                                            <input type="text"
                                                className="form-control"                                               
                                                autoComplete="off"
                                                value={name}
                                                 onKeyDown={(e)=>handleEnterFocus(e,userNameRef)}
                                                onChange={(e) =>{
                                                    setErrors("");                                                    
                                                    const value =e.target.value.replace(/\s+/g, ' ').replace(/^\s/, '')
                                                    setName(value);                                                    
                                                      if (!selectedStaff) { 
                                                    const generated = value.toLowerCase().replace(/[^a-z0-9]/g, "");
                                                    setUserName(generated);
                                                      }
                                                    setSuggestions([])
                                                }}
                                                ref={nameRef}
                                                autoFocus
                                            />
                                            {error.name && (
                                                <div className="error-message invalid-feedback" >
                                                    {error.name}
                                                </div>
                                            )}
                                        </div>
                                            
                                        <div className="col-lg-12">
                                            <label htmlFor="staff-username-input" className="form-label">UserName <span className="text-danger">*</span>  {error.userNameAvailable && (
                                                <span className="error-message invalid-feedback" >
                                                    ({error.userNameAvailable})
                                                </span>
                                            )} </label>
                                            <div ref={wrapperRef} className="position-relative">
                                            <input type="text"
                                                name='staff-username'
                                                id="staff-username-input"
                                                className="form-control"                                                
                                                autoComplete="off"
                                                value={userName}
                                                onKeyDown={(e) => {
                                                    if (suggestions.length > 0) {
                                                        if (e.key === "ArrowDown") {
                                                        e.preventDefault();
                                                        setHighlightedIndex((prev) =>
                                                            prev < suggestions.length - 1 ? prev + 1 : 0
                                                        );
                                                        } else if (e.key === "ArrowUp") {
                                                        e.preventDefault();
                                                        setHighlightedIndex((prev) =>
                                                            prev > 0 ? prev - 1 : suggestions.length - 1
                                                        );
                                                        }else if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            const indexToSelect =
                                                            highlightedIndex >= 0 ? highlightedIndex : 0; 
                                                        handleSuggestionClick(suggestions[indexToSelect]);
                                                        }
                                                    } else {
                                                        handleEnterFocus(e, passwordRef);
                                                    }
                                                    }}
                                                    
                                                onChange={(e) => {setErrors("");setSuggestions(""); setUserName(e.target.value.toLowerCase().replace(/[^a-z0-9]/g, ''))}}                                          
                                                ref={userNameRef}
                                                disabled={!!selectedStaff}
                                                
                                            />  
                                            {suggestions.length > 0 && (
                                            <ul className="suggestions-list position-relative mt-1">
                                                {suggestions.map((sug, i) => (
                                                <li    className={`suggestion-item text-muted ${
                                                    i === highlightedIndex || (highlightedIndex === -1 && i === 0)
                                                    ? "highlighted"
                                                    : ""
                                                }`}
                                                    key={i}   
                                                    ref={(e) => (suggestionRef.current[i] = e)}                                                
                                                    onClick={() =>{ handleSuggestionClick(sug);}}
                                                >
                                                    {sug}
                                                </li>                                                
                                                ))}
                                            </ul>
                                            )}
                                            </div>
                                            {error.userName && (
                                                <div className="error-message invalid-feedback" >
                                                    {error.userName}
                                                </div>
                                            )}                                       

                                        </div>
                                          
                                        <div className="col-lg-12">
                                            <label htmlFor="staff-password-input" className="form-label">{selectedStaff ?"New Password ":"Password"} <span className="text-danger">*</span></label>
                                            <input type="text"
                                                id='staff-password-input'
                                                className="form-control"
                                                autoComplete="off"
                                                value={password}
                                                maxLength={16}
                                                ref={passwordRef}
                                                onKeyDown={(e)=>handleEnterFocus(e,buttonRef)}
                                                onChange={(e) => {setErrors(""); setPassword(e.target.value.replace(/\s+/g, ''))}}
                                                name="staff-password" />

                                            {error.password && (
                                                <div className="error-message invalid-feedback" >
                                                    {error.password}
                                                </div>
                                            )}
                                        </div>                                       
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer d-block">
                            <button type="button" className="btn btn-outline-secondary text-left" onClick={handleClose}>
                                <XIcon/> Close
                            </button>
                            {isBtnLoading ? (
                                <button className="btn btn-primary pb-0 text-right" disabled>
                                    <CircularProgress size={22} className="text-white" />
                                </button>
                            ) : (
                                <button ref={buttonRef} type="button" className="btn btn-primary text-right"
                                    onClick={handleSubmit}>
                                    <i className={`${selectedStaff? "bx bx-check" :"ng ng-ng-add-icon"}`}></i> {selectedStaff? "Update":"Add"} 
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddStaff.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
};

export default AddStaff;